import timg1 from "../images/slider/edy2.jpg";

const Teams = [
  {
    id: "1",
    tImg: timg1,
    name: "Dra. Edy Rodrigues",
    slug: "Dra-Edy-Rodruigues",
    title: "Psicopedagoga Clínica",
    animation: "1000",
  },
];

export default Teams;
